export default __webpack_public_path__ + "static/media/product-item-03.739e49ea.jpg";